var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DropdownButton, DropdownButtonContext, List, } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import React, { memo, useCallback } from 'react';
import { analytics } from 'app/utils/segment';
import { TimelineIcon } from '../../timelineIcon';
import styles from './index.module.scss';
import { TimelineItemRow } from './timelineItemRow/timelineItemRow';
export const TimelineItem = memo(function TimelineItem(_a) {
    var { className, conversations: timelineConversations, status, isCurrent, onConversationSelect, nodeRef } = _a, otherProps = __rest(_a, ["className", "conversations", "status", "isCurrent", "onConversationSelect", "nodeRef"]);
    const handleOnDropdownToggle = useCallback((isOpen) => {
        if (isOpen) {
            analytics.conversationTimelineItemOpened();
        }
    }, []);
    const rootClass = classnames({
        [styles.root]: true,
        [styles.rootOpen]: status === 'open',
        [styles.rootFollowUp]: status === 'pending' || status === 'awaitingpending',
        [styles.rootCurrent]: isCurrent,
    }, className);
    return (_jsx("div", Object.assign({}, otherProps, { className: rootClass, ref: nodeRef }, { children: _jsxs(DropdownButton, Object.assign({ buttonProps: {
                className: styles.cluster,
            }, noArrow: true, fixed: true, onToggle: handleOnDropdownToggle, dropdown: _jsx(DropdownButtonContext.Consumer, { children: (props) => (_jsx(List, Object.assign({ className: styles.conversations }, { children: timelineConversations.map((item, index) => (_jsx(TimelineItemRow, { index: index, conversation: item, onConversationSelect: onConversationSelect, toggleDropdown: props.toggleDropdown }, item.id))) }))) }) }, { children: [timelineConversations.length > 1 && (_jsx(React.Fragment, { children: timelineConversations.length })), timelineConversations.length === 1 && (_jsx(TimelineIcon, { channel: timelineConversations[0].channel, isClosed: timelineConversations[0].status === 'closed', hasFollowUp: timelineConversations[0].hasFollowUp }))] })) })));
});
